/**
 * Product Option Details Dynamic Updates
 * Updates detail text when product variants are selected
 */

class ProductOptionDetails {
  constructor() {
    this.init();
  }

  init() {
    // Listen for variant changes
    document.addEventListener('DOMContentLoaded', () => {
      this.attachListeners();
    });

    // Also listen for Shopify section reloads
    document.addEventListener('shopify:section:load', () => {
      this.attachListeners();
    });
  }

  attachListeners() {
    // Listen for variant changes using Shopify's variant change event
    document.addEventListener('variant:change', (e) => {
      this.updateAllDetailTexts();
    });

    // Also listen for radio button changes as fallback
    document.addEventListener('change', (e) => {
      if (e.target.type === 'radio' && e.target.closest('.product__variant-options')) {
        // Small delay to ensure Shopify's variant logic runs first
        setTimeout(() => {
          this.updateAllDetailTexts();
        }, 50);
      }
    });
  }

  updateAllDetailTexts() {
    // Find all variant option fieldsets and update their detail text
    const optionFieldsets = document.querySelectorAll('.product__variant-options[data-option-name]');

    optionFieldsets.forEach(fieldset => {
      const selectedInput = fieldset.querySelector('input[type="radio"]:checked');
      if (selectedInput) {
        this.updateDetailText(fieldset, selectedInput);
      }
    });
  }

  updateDetailText(fieldset, selectedInput) {
    const detailContainer = fieldset.querySelector('[data-option-detail]');

    if (!detailContainer) return;

    // Get the detail text from the selected input's data attribute
    const detailText = selectedInput.getAttribute('data-option-detail');

    // Clear existing detail text first
    detailContainer.innerHTML = '';

    if (detailText && detailText.trim() !== '') {
      detailContainer.innerHTML = ` - <strong>${detailText}</strong>`;
    }
  }

  updateDetailTextFromDropdown(fieldset, selectedOption) {
    const detailContainer = fieldset.querySelector('[data-option-detail]');

    if (!detailContainer) return;

    // Get the detail text from the selected option's data attribute
    const detailText = selectedOption.getAttribute('data-option-detail');

    if (detailText && detailText.trim() !== '') {
      detailContainer.innerHTML = ` - <strong>${detailText}</strong>`;
    } else {
      detailContainer.innerHTML = '';
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ProductOptionDetails();
  });
} else {
  new ProductOptionDetails();
}

// Export for use in other modules if needed
window.ProductOptionDetails = ProductOptionDetails;

